import React from 'react'
import Loadable from 'react-loadable'
import Loading from 'scripts/components/static/Loading'

// NOTES: Strangely this refactor does not work on server side rendering.
//        It causes some of html elemets to lose its attribute. Must be a bug
//        in the reac-loadable library

// import SyncLoadable from 'scripts/lib/SyncLoadable'

// const Home = SyncLoadable('HomeChunk', () => import(/* webpackChunkName: "HomeChunk" */ './components/home'))
// const Article = SyncLoadable('ArticleChunk', f => import(/* webpackChunkName: "ArticleChunk" */ './components/article'))
// const Listings = SyncLoadable('ListingsChunk', f => import(/* webpackChunkName: "ListingsChunk" */ './components/listings'))
// const WordpressPages = SyncLoadable('WordpressPagesChunk', f => import(/* webpackChunkName: "WordpressPagesChunk" */ './components/WordpressPages'))
// const NotFound = SyncLoadable('NotFoundChunk', f => import(/* webpackChunkName: "NotFoundChunk" */ './components/notfound'))
// const Search = SyncLoadable('SearchChunk', f => import(/* webpackChunkName: "SearchChunk" */ './components/Search'))
// const ProfileEdit = SyncLoadable('ProfileEditChunk', f => import(/* webpackChunkName: "ProfileEditChunk" */ './components/ProfileEdit'))

function LoadingComponent(props) {
  if (props.error) {
    return (
      <div>Error!</div>
    )
  } else if (props.pastDelay) {
    // only show loading component when it is past the delayed time, which is 200ms
    return (
      <Loading />
    )
  } else {
    return null
  }
}

class Home extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "HomeChunk" */ './components/home'),
    loading: LoadingComponent,
    modules: ['HomeChunk']
  })
  render() {
    return <Home.Component {...this.props} />
  }
}

class Article extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "ArticleChunk" */ './components/article'),
    loading: LoadingComponent,
    modules: ['ArticleChunk']
  })
  render() {
    return <Article.Component {...this.props} />
  }
}

class Listings extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "ListingsChunk" */ './components/listings'),
    loading: LoadingComponent,
    modules: ['ListingsChunk']
  })
  render() {
    return <Listings.Component {...this.props} />
  }
}

class WordpressPages extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "WordpressPagesChunk" */ './components/WordpressPages'),
    loading: LoadingComponent,
    modules: ['WordpressPagesChunk']
  })
  render() {
    return <WordpressPages.Component {...this.props} />
  }
}

class NotFound extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "NotFoundChunk" */ './components/notfound'),
    loading: LoadingComponent,
    modules: ['NotFoundChunk']
  })
  render() {
    return <NotFound.Component {...this.props} />
  }
}

class Search extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "SearchChunk" */ './components/Search'),
    loading: LoadingComponent,
    modules: ['SearchChunk']
  })
  render() {
    return <Search.Component {...this.props} />
  }
}

class ProfileEdit extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "ProfileEditChunk" */ './components/ProfileEdit'),
    loading: LoadingComponent,
    modules: ['ProfileEditChunk']
  })
  render() {
    return <ProfileEdit.Component {...this.props} />
  }
}

class SubmitTip extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "SubmitTipChunk" */ './components/SubmitTip'),
    loading: LoadingComponent,
    modules: ['SubmitTipChunk']
  })
  render() {
    return <SubmitTip.Component {...this.props} />
  }
}

class Embed extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "EmbedChunk" */ './components/Embed'),
    loading: LoadingComponent,
    modules: ['EmbedChunk']
  })
  render() {
    return <Embed.Component {...this.props} />
  }
}

class Privacy extends React.Component {
  static Component = Loadable({
    loader: () => import(/* webpackChunkName: "PrivacyChunk" */ './components/Privacy'),
    loading: LoadingComponent,
    modules: ['PrivacyChunk']
  })
  render() {
    return <Privacy.Component {...this.props} />
  }
}

module.exports = {
  Home,
  Article,
  Listings,
  WordpressPages,
  NotFound,
  Search,
  ProfileEdit,
  SubmitTip,
  Embed,
  Privacy
}



// WEBPACK FOOTER //
// ./assets/js/sync-bundle.jsx